import { c as _c } from "react/compiler-runtime";
import { UnprocessableError } from '@netpurpose/api';
import { useAlertBanner } from '@netpurpose/core';
import { QueryClientProvider, useQueryClient } from '@tanstack/react-query';
import { type FC, useEffect } from 'react';
import { AlertBannerType } from '#components/common/AlertBanner';
const GlobalErrorBanner: FC<{
  children: React.ReactNode;
}> = t0 => {
  const $ = _c(7);
  const {
    children
  } = t0;
  const {
    showAlertBanner
  } = useAlertBanner();
  const queryClient = useQueryClient();
  let t1;
  let t2;
  if ($[0] !== queryClient || $[1] !== showAlertBanner) {
    t1 = () => {
      queryClient.setDefaultOptions({
        mutations: {
          ...queryClient.getDefaultOptions().mutations,
          onError: err => {
            if (err instanceof UnprocessableError) {
              showAlertBanner(AlertBannerType.MutationError, err.message);
            } else {
              showAlertBanner(AlertBannerType.GeneralError);
            }
          }
        },
        queries: {
          ...queryClient.getDefaultOptions().queries,
          retry: failureCount => {
            const shouldRetry = failureCount < 3;
            if (!shouldRetry) {
              showAlertBanner(AlertBannerType.GeneralError);
            }
            return shouldRetry;
          }
        }
      });
    };
    t2 = [queryClient, showAlertBanner];
    $[0] = queryClient;
    $[1] = showAlertBanner;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== children || $[5] !== queryClient) {
    t3 = <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
    $[4] = children;
    $[5] = queryClient;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default GlobalErrorBanner;